<template>
    <div >
        <div style="margin: 0px; padding: 0px;">
            <div style="background: #FFFFFF; color: #666666; font-weight: 400; padding-top: 5px; padding-bottom: 5px; text-align: center; width: 100%; font-size: 12px; font-family: PingFangSC-Regular, PingFang SC;">
                <span>开发者：北京中网易企秀科技有限公司</span><br/>
                <span>应用名称：易企秀设计</span> <span style="padding-left: 20px;">版本号：4.36.0</span><br/>
                <span><a href="http://lps.eqxiul.com/ls/d2OO1JzU" style="color: #246DFF;">用户权限</a> | <a href="http://lps.eqxiul.com/ls/d2OO1JzU" style="color: #246DFF;">隐私协议</a></span>
            </div>
            <img :src="awaken_img" style="width: 100%; display: block;" title="awaken" @click="openApp" v-trigger>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                awaken_img: '//asset.eqh5.com/app_awaken_10988?t=' + new Date().getFullYear() + "-" + new Date().getMonth()+ "-" + new Date().getDate() + "-" + new Date().getHours() +"&imageMogr2/auto-orient/thumbnail/" + (window.outerWidth * 1.5) + "x" + (window.innerHeight * 1.5),
            }
        },
        directives: {
            trigger: {
                inserted(el, binging) {
                    el.click()
                }
            }
        },
        methods: {
            openApp() {
                window.location = 'https://apps.apple.com/cn/app/yi-qi-xiu/id933128780';
            }
        }
    }
</script>

<style scoped>

</style>
